/** Terrazzo's four shapes (mirrors scripts/mark.mjs — keep in sync). Filled reads better small; outlined is for big. */
const NOTCHED = 'M58 13H82A5 5 0 0 1 87 18V42A5 5 0 0 1 82 47H75A5 5 0 0 1 70 42V35A5 5 0 0 0 65 30H58A5 5 0 0 1 53 25V18A5 5 0 0 1 58 13Z'
const RING = 'M66 53H83A4 4 0 0 1 87 57A34 34 0 0 1 57 87A4 4 0 0 1 53 83V66A13 13 0 0 0 66 53Z'

function Shapes({ filled, color, strokeWidth = 6 }: { filled: boolean; color: string; strokeWidth?: number }) {
  return filled ? (
    <g fill={color}>
      <circle cx="30" cy="30" r="17" />
      <path d={NOTCHED} />
      <rect x="13" y="53" width="34" height="34" rx="7" />
      <path d={RING} />
    </g>
  ) : (
    <g fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="30" cy="30" r="16" />
      <path d={NOTCHED} />
      <rect x="13" y="53" width="34" height="34" rx="7" />
      <path d={RING} />
    </g>
  )
}

/** The mark on its dark tile: filled below 40px (the sidebar), outlined above (sign-in, loading). */
export function Logo({ size = 32, className = '', filled = size < 40 }: { size?: number; className?: string; filled?: boolean }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
      <rect width="100" height="100" rx="22" fill="#0a0a0a" />
      <Shapes filled={filled} color="#fff" strokeWidth={3.2} />
    </svg>
  )
}

/** Just the four shapes, filled, in the current text color (for the + button's hold state, etc.). */
export function LogoMark({ size = 24, className = '' }: { size?: number; className?: string }) {
  return (
    <svg width={`${size / 16}rem`} height={`${size / 16}rem`} viewBox="11 11 78 78" className={className} aria-hidden="true" data-logo-mark>
      <Shapes filled color="currentColor" />
    </svg>
  )
}
